import React from 'react';
import { motion } from 'framer-motion';
export function HeritageSection() {
  const statements = ['Established UK manufacturer since 2009', 'In-house production and quality control', 'Built for industrial and compliance-led environments', 'Flexible ordering from short runs to volume production'];
  return <section className="py-20 md:py-24 bg-[#0A1628] relative overflow-hidden" data-id="element-200">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 relative" data-id="element-201">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-start" data-id="element-202">
          {/* Column 1 - Large Headline */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-203">
            <div className="flex items-center gap-3 mb-6" data-id="element-204">
              <span className="text-4xl" data-id="element-205">🇬🇧</span>
              <span className="text-sm font-semibold text-slate-500 uppercase tracking-widest" data-id="element-206">
                UK Manufactured
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.1] tracking-tight" data-id="element-207">
              Why businesses
              <br data-id="element-208" />
              <span className="text-white/30" data-id="element-209">order from us</span>
            </h2>
          </motion.div>

          {/* Column 2 - Typography-led statements */}
          <div className="lg:pt-4" data-id="element-210">
            <div className="space-y-6" data-id="element-211">
              {statements.map((statement, index) => <motion.p key={index} initial={{
              opacity: 0,
              x: 20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1
            }} className="text-xl md:text-2xl text-white/80 leading-snug pl-6 border-l-2 border-[#0052CC]" data-id="element-212">
                  {statement}
                </motion.p>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}